import type { SVGProps } from 'react'
import { cn } from '@/lib/cn'

type Glyph = { d: string; evenOdd?: true }

const glyphs = {
  check: { d: 'M9.55 17.6 4.4 12.45l1.4-1.4 3.75 3.75 8.65-8.65 1.4 1.4Z' },
  close: {
    d: 'M6.4 19 5 17.6l5.6-5.6L5 6.4 6.4 5l5.6 5.6L17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6Z',
  },
  plus: { d: 'M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6Z' },
  chevronDown: { d: 'M12 15.4 5.6 9 7 7.6l5 5 5-5L18.4 9Z' },
  chevronRight: { d: 'M9 18.4 7.6 17l5-5-5-5L9 5.6 15.4 12Z' },
  arrowUp: { d: 'M11 20V7.8l-4.6 4.6L5 11l7-7 7 7-1.4 1.4L13 7.8V20Z' },
  arrowDown: { d: 'M11 4h2v12.2l4.6-4.6L19 13l-7 7-7-7 1.4-1.4 4.6 4.6Z' },
  dot: { d: 'M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z' },
  dotHollow: {
    d: 'M12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm0 2.2a3.8 3.8 0 1 1 0 7.6 3.8 3.8 0 0 1 0-7.6Z',
    evenOdd: true,
  },
  clock: {
    d: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 2.4a7.6 7.6 0 1 1 0 15.2 7.6 7.6 0 0 1 0-15.2Zm1.1 3.1h-1.8v5.1l4.2 2.5.9-1.5-3.3-2Z',
    evenOdd: true,
  },
  clockOff: {
    d: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 2.4a7.6 7.6 0 1 1 0 15.2 7.6 7.6 0 0 1 0-15.2ZM5.6 4.2 4.2 5.6 18.4 19.8l1.4-1.4Z',
    evenOdd: true,
  },
  xCircle: {
    d: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4.2 12.8-1.4 1.4L12 13.4l-2.8 2.8-1.4-1.4L10.6 12 7.8 9.2l1.4-1.4L12 10.6l2.8-2.8 1.4 1.4L13.4 12Z',
    evenOdd: true,
  },
  minusCircle: {
    d: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-5 9h10v2H7Z',
    evenOdd: true,
  },
  info: {
    d: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1 5h2v2h-2Zm0 4h2v7h-2Z',
    evenOdd: true,
  },
  alertTriangle: {
    d: 'M12 2.6 1.2 21.4h21.6ZM11.1 9h1.8v6h-1.8Zm0 7.5h1.8v1.9h-1.8Z',
    evenOdd: true,
  },
  shieldCheck: {
    d: 'M12 2 4 5.1v6.2c0 5 3.4 9.7 8 10.7 4.6-1 8-5.7 8-10.7V5.1Zm4.3 6.6 1.4 1.4-6 6-3.4-3.4 1.4-1.4 2 2Z',
    evenOdd: true,
  },
  upload: {
    d: 'M11 15.4V8.2L8.4 10.8 7 9.4l5-5 5 5-1.4 1.4L13 8.2v7.2Zm-6 4.2v-4.2h2v2.2h10v-2.2h2v4.2Z',
  },
  download: {
    d: 'M12 16.4l-5-5 1.4-1.4 2.6 2.6V5.4h2v7.2l2.6-2.6 1.4 1.4Zm-7 3.2v-4.2h2v2.2h10v-2.2h2v4.2Z',
  },
  send: { d: 'M3 20.6V13l9-1-9-1V3.4L21.6 12Z' },
  copy: {
    d: 'M8 2h12v12h-2V4H8Zm-4 5h12v15H4Zm2 2v11h8V9Z',
    evenOdd: true,
  },
  eye: {
    d: 'M12 5.5c-4.6 0-8.4 2.9-10 6.5 1.6 3.6 5.4 6.5 10 6.5s8.4-2.9 10-6.5c-1.6-3.6-5.4-6.5-10-6.5Zm0 3.1a3.4 3.4 0 1 1 0 6.8 3.4 3.4 0 0 1 0-6.8Z',
    evenOdd: true,
  },
  eyeOff: {
    d: 'M12 5.5c-4.6 0-8.4 2.9-10 6.5 1.6 3.6 5.4 6.5 10 6.5s8.4-2.9 10-6.5c-1.6-3.6-5.4-6.5-10-6.5Zm0 3.1a3.4 3.4 0 1 1 0 6.8 3.4 3.4 0 0 1 0-6.8ZM4.2 2.8 2.8 4.2 19.8 21.2l1.4-1.4Z',
    evenOdd: true,
  },
  search: {
    d: 'M10.5 3a7.5 7.5 0 0 1 5.92 12.09l4.99 4.99-1.41 1.41-4.99-4.99A7.5 7.5 0 1 1 10.5 3Zm0 2.1a5.4 5.4 0 1 0 0 10.8 5.4 5.4 0 0 0 0-10.8Z',
    evenOdd: true,
  },
  spinner: { d: 'M12 2a10 10 0 0 1 10 10h-2.6A7.4 7.4 0 0 0 12 4.6Z' },
  sun: {
    d: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-1-6h2v3h-2Zm0 17h2v3h-2ZM2 11h3v2H2Zm17 0h3v2h-3ZM4.2 5.6 5.6 4.2 7.7 6.3 6.3 7.7Zm12.1 12.1 1.4-1.4 2.1 2.1-1.4 1.4ZM18.4 4.2l1.4 1.4-2.1 2.1-1.4-1.4ZM4.2 18.4l2.1-2.1 1.4 1.4-2.1 2.1Z',
  },
  moon: {
    d: 'M12 3a9 9 0 1 0 9 9c0-.46-.04-.92-.1-1.36a5.39 5.39 0 0 1-4.4 2.26 5.4 5.4 0 0 1-5.4-5.4c0-1.81.9-3.4 2.26-4.4A9.5 9.5 0 0 0 12 3Z',
  },
  monitor: {
    d: 'M3 4h18v12H3Zm2 2v8h14V6Zm3 12h8v2H8Z',
    evenOdd: true,
  },
  menu: { d: 'M3 6h18v2H3Zm0 5h18v2H3Zm0 5h18v2H3Z' },
  refresh: {
    d: 'M17.65 6.35A8 8 0 1 0 19.73 14h-2.08A6 6 0 1 1 12 6c1.66 0 3.14.69 4.22 1.78L13 11h7V4Z',
  },
  grid: { d: 'M3 3h8v8H3Zm10 0h8v8h-8ZM3 13h8v8H3Zm10 0h8v8h-8Z' },
  globe: {
    d: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 2.2a7.8 7.8 0 1 1 0 15.6 7.8 7.8 0 0 1 0-15.6Zm-1.1 0h2.2v15.6h-2.2ZM4.2 10.9h15.6v2.2H4.2Z',
    evenOdd: true,
  },
  chart: { d: 'M4 20V10h4v10Zm6 0V4h4v16Zm6 0v-6h4v6Z' },
  key: {
    d: 'M15 2a6.5 6.5 0 0 0-6.2 8.5L2 17.3V22h4.7l1.1-1.1v-2.1h2.1v-2.1h2.1l1.2-1.2A6.5 6.5 0 1 0 15 2Zm1.8 3.2a2 2 0 1 1-2 2 2 2 0 0 1 2-2Z',
    evenOdd: true,
  },
  code: {
    d: 'M8.6 16.6 4 12l4.6-4.6L10 8.8 6.8 12l3.2 3.2Zm6.8 0L14 15.2 17.2 12 14 8.8l1.4-1.4L20 12Z',
  },
  wallet: {
    d: 'M2 6h20v12H2Zm2 2v8h16V8Zm8 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z',
    evenOdd: true,
  },
  box: {
    d: 'M12 2 3 7v10l9 5 9-5V7Zm0 2.3 6.8 3.7L12 11.7 5.2 8Z',
    evenOdd: true,
  },
  help: {
    d: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1 15h2v2h-2Zm1-10a3.2 3.2 0 0 1 1.9 5.8c-.6.5-.9.8-.9 1.7h-2c0-1.6.6-2.3 1.5-3a1.2 1.2 0 1 0-1.9-1H9.6A2.6 2.6 0 0 1 12 7Z',
    evenOdd: true,
  },
  user: {
    d: 'M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 10c-4.4 0-8 2.2-8 5v1h16v-1c0-2.8-3.6-5-8-5Z',
  },
  logOut: { d: 'M10 3v2H6v14h4v2H4V3Zm5.6 4.6L14.2 9l2 2H9v2h7.2l-2 2 1.4 1.4L20 12Z' },
} satisfies Record<string, Glyph>

export type IconName = keyof typeof glyphs

type IconProps = Omit<SVGProps<SVGSVGElement>, 'name' | 'children'> & {
  name: IconName
}

export function Icon({ name, className, ...rest }: IconProps) {
  const glyph: Glyph = glyphs[name]

  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={cn('size-5 shrink-0', className)}
      {...rest}
    >
      <path d={glyph.d} fillRule={glyph.evenOdd ? 'evenodd' : undefined} />
    </svg>
  )
}
